import React from "react";
import { GecoComponentRouter } from "components/GecoComponentRouter";
import { BackButton } from "components/BackButton/BackButton";

export const NewDetailPage = ({ detail, locale, onBack, darkMode }) => {
  return (
    <>
      <BackButton onBack={onBack} darkMode={darkMode} />
      <GecoComponentRouter components={detail.gecoComponents} lang={locale} />
    </>
  );
};
